import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=4e00894e&"
import script from "./BaseFilter.vue?vue&type=script&lang=ts&"
export * from "./BaseFilter.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./BaseFilter.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mfe-shared/mfe-shared/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e00894e')) {
      api.createRecord('4e00894e', component.options)
    } else {
      api.reload('4e00894e', component.options)
    }
    module.hot.accept("./BaseFilter.vue?vue&type=template&id=4e00894e&", function () {
      api.rerender('4e00894e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseFilter.vue"
export default component.exports